import protoRoot from "../proto-root";

function create() {
  const SupportedFeaturesType = protoRoot.lookupEnum("comm.SupportedFeaturesType");
  const { values } = SupportedFeaturesType;
  const supportedFeatures: number[] = [
    values["WEBRTC_PERFECT_NEGOTIATION"],
    values["CAMERA_STATION_STOP_RECORDING"],
    values["SINGLE_MOTION_DETECTION_ZONE"],
    values["CAMERA_STATION_ALARM"],
    values["CAMERA_STATION_FLASHLIGHT_NOT_SUPPORTED"],
    values["CAMERA_STATION_LOW_LIGHT_NOT_SUPPORTED"],
    values["CAMERA_STATION_VIDEO_RECORDING"],
    values["CAMERA_STATION_INSTANT_VIDEO"],
    values["WEBRTC_TRANSCEIVERS_V2"]
  ];

  return supportedFeatures;
}

const supportedFeatures = { create };

export default supportedFeatures;
